export const FINANCIAL_IDS = {
    "FINANCEIRA_GSC": 1,
    "BBVA": 2,
    "BMW_FS": 3,
    "SANTANDER_CONSUMER": 4,
    "GE_MONEY": 5,
    "BPI": 6,
    "CGD": 7,
    "CETELEM": 8,
    "CREDIBOM": 9,
    "PSA_FINANCE": 10,
    "FGA": 11,
    "BBVA_ESPANHA": 12,
    "SOFINCO": 13,
    "TOYOTA_KREDITBANK_GMBH": 14,
    "CAIXABANK": 15,
    "CETELEM_ES": 16,
    "SABADELL": 17,
    "SANTANDER_CONSUMER_ES": 18,
    "COFIDIS_PT": 19,
};
